import React from "react";
import classNames from "classnames/bind";
import { useNavigate } from "react-router-dom";
import { useStoreContext } from "../../../../hooks/useStoreContext";
import { actions } from "../../../../store";
import styles from "./StreamCam.module.css";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);
const SettingCamera = ({
  show,
  item,
  code,
  showInfoCamera,
 
  restartCamera,
  showSettingModal,
  onShowRename,
  setNameCamera,
  isSearchCam,
  reFreshCamera
}) => {
  const navigate = useNavigate();
  const [dataStore, dispatch] = useStoreContext();
  const { t } = useTranslation();
  return (
    <>
      {show && (item.code === code) && (
        <div className={cx("options")}>
          <ul className={cx("list")}>
            <li
              className={cx("item")}
              onClick={() => showInfoCamera(item.code)}
            >
              {t("stream.infoCamera")}
            </li>
            <li
              className={cx("item")}
              onClick={() => showSettingModal(item.code)}
            >
              {t("stream.settingCamera")}
            </li>
            <li className={cx("item")} onClick={() => restartCamera(item.code)}>
              {t("stream.restart")}
            </li>
            <li
              className={cx("item")}
              onClick={() => {
                let dataAdd = {
                  type: "cam",
                  add: true,
                  data: [
                    {
                      name: item.name,
                      code: item.code,
                      status: false,
                      camStatusActive:
                        item.status === "On"
                          ? 1
                          : item.status === "Off"
                            ? 4
                            : 3,
                    },
                  ],
                  // warehouseCode: wareHouseCode,
                };
                dispatch(actions.getListCodeCamera(dataAdd));
                navigate("/playback-video");
              }}
            >
              {t("stream.playback")}
            </li>
            <li
              className={cx("item")}
              onClick={() => {
                onShowRename(item);
                setNameCamera(item);
              }}
            >
              {t("stream.rename")}
            </li>
            <li className={cx("item")} onClick={() => reFreshCamera(item.code, true)}>
              {t("stream.refresh")}
            </li>
          </ul>
        </div>
      )}
    </>
  );
};

export default SettingCamera;
